import {UmpireComponent} from '../umpire-component';
import {UmpireComponentTypeEnum} from '../umpire-component-type-enum';

export interface UmpireComponentFaq extends UmpireComponent<UmpireComponentTypeEnum.FAQ> {
  faq_questions: UmpireComponentFaqQuestion[];
  questions_order: FaqQuestionOrder[];
}

export interface FaqQuestionOrder {
  faq_question_id: string;
  faq_question_index: number;
}

export interface UmpireComponentFaqQuestion {
  id: string | null;
  question: string;
  answer: string;
  type: 'question';
}
